import loadable from '@loadable/component';

export const OrgDashboardPayByCreditCardContainerLoadable = loadable(
  () => import('./OrgDashboardPayByCreditCardContainer'),
  { resolveComponent: (module) => module.OrgDashboardPayByCreditCardContainer },
);
